'use client'

import dynamic from 'next/dynamic'

// Defer analytics to load after hydration (bundle-defer-third-party)
// These are loaded client-side only to avoid blocking initial render
const Analytics = dynamic(
  () => import('@vercel/analytics/next').then((m) => m.Analytics),
  { ssr: false }
)

const SpeedInsights = dynamic(
  () => import('@vercel/speed-insights/next').then((m) => m.SpeedInsights),
  { ssr: false }
)

export function DeferredAnalytics(): React.ReactNode {
  return (
    <>
      <Analytics />
      <SpeedInsights />
    </>
  )
}
